(() => {
  // ---------------------------------------------------------------------
  // 1) Ensure Shopify.formatMoney is defined (same code you had inline)
  // ---------------------------------------------------------------------
  if (!Shopify.formatMoney) {
    Shopify.money_format = null;
    Shopify.formatMoney = cents =>
      Shopify.money_format.replace(/\{\{\s*amount\s*\}\}/g, (cents/100).toFixed(2));
  }

  // ---------------------------------------------------------------------
  // 2) Star-rendering helper (same as before)
  // ---------------------------------------------------------------------
  function renderStars(el, rating) {
    const STAR_SVG = `Liquid error: This liquid context does not allow includes.`;
    el.innerHTML   = `${STAR_SVG}<span>${rating.toFixed(1)}</span>`;
  }

  function toCardRecommendation(rec) {
    const primaryImage = rec?.featured_image?.url || rec?.image?.src || rec?.image?.url || rec?.image || rec?.images?.[0]?.src || rec?.images?.[0]?.url || '';
    const imageAlt = rec?.featured_image?.alt || rec?.image?.alt || rec?.title || '';
    const selectedVariantId = rec?.selected_or_first_available_variant_id || rec?.variants?.[0]?.id || null;
    const variantCount = Number(rec?.variant_count || rec?.variants?.length || 0);
    const available = typeof rec?.available === 'boolean' ? rec.available : (rec?.variants?.[0]?.available ?? true);
    const priceMin = Number.isFinite(Number(rec?.price_min)) ? Number(rec.price_min) : rec?.variants?.[0]?.price != null ? Math.round(parseFloat(rec.variants[0].price) * 100) : null;

    return {
      id: rec?.id ?? rec?.product_id ?? null,
      url: rec?.url || rec?.link || (rec?.handle ? `/products/${rec.handle}` : null),
      title: rec?.title || '',
      image: { src: primaryImage, alt: imageAlt },
      variantId: selectedVariantId,
      variantCount,
      available,
      priceCents: priceMin,
      rating: rec?.metafields?.loox?.avg_rating ?? null,
      reason: rec?.reason || null
    };
  }

  function getRecSessionId() {
    let id;
    try { id = sessionStorage.getItem('rec_session_id'); } catch {}
    if (!id) {
      id = window.__recSessionId || (crypto.randomUUID ? crypto.randomUUID() : `rec-session-${Date.now()}`);
      try { sessionStorage.setItem('rec_session_id', id); } catch {}
    }
    window.__recSessionId = id;
    return id;
  }

  function sendRecEvent(payload) {
    const body = JSON.stringify({
      ...payload,
      session_id: getRecSessionId(),
      page_path: window.location.pathname,
      timestamp: new Date().toISOString()
    });

    const endpoint = 'https://api.sowandarrow.com/recommendations';
    const pingUrl = `${endpoint}?rx=1&d=${encodeURIComponent(body)}`;
    const img = new Image();
    window.__recoEventPings = window.__recoEventPings || [];
    window.__recoEventPings.push(img);
    img.onload = img.onerror = () => {
      window.__recoEventPings = window.__recoEventPings.filter((x) => x !== img);
    };
    img.src = pingUrl;
  }

  const sentImpressions = new Set();
  function observeRecImpression(el, payload) {
    if (!el) return;
    const key = [
      payload.placement || 'unknown',
      payload.request_uuid || 'no-request',
      payload.variant_id || payload.product_id || 'no-product'
    ].join('|');
    if (sentImpressions.has(key)) return;

    const observer = new IntersectionObserver((entries, obs) => {
      if (!entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= 0.35)) return;
      sentImpressions.add(key);
      sendRecEvent({ ...payload, event_type: 'recommendation_impression' });
      obs.disconnect();
    }, { threshold: [0.35] });

    observer.observe(el);
  }

  // ---------------------------------------------------------------------
  // 3) Main cross-sell logic
  // ---------------------------------------------------------------------
  document.addEventListener('DOMContentLoaded', () => {
    // Find all product-page (and cart-page) cross-sells on the current page
    document.querySelectorAll('.cross-sell-section').forEach(async (wrapper) => {
      const carouselId = wrapper.dataset.carouselId;
      const seedId     = wrapper.dataset.seedId;
      const details    = wrapper.querySelector('details.accordion__disclosure');
      const summary    = wrapper.querySelector('summary');
      const carousel   = wrapper.querySelector(`#${carouselId}`);
      const tpl        = document.getElementById(`${carouselId}-template`);
      const prevBtn    = wrapper.querySelector(`#${carouselId}-prev`);
      const nextBtn    = wrapper.querySelector(`#${carouselId}-next`);
      if (!details || !summary || !carousel || !tpl) return;

      // disable manual accordion-click until we auto-open
      let readyToOpen = false;
      summary.style.pointerEvents = 'none';
      summary.addEventListener('click', e => {
        if (!readyToOpen) e.preventDefault();
      }, true);

      // 3.1) Fetch cart
      let cart = { items: [], item_count: 0, items_subtotal_price: 0 };
      try {
        cart = await fetch('/cart.js').then(r => r.json());
      } catch (e) { console.warn('[Product] cart.js failed', e); }
      const inCart = new Set(cart.items.map(i => String(i.variant_id)));
      const customerProfile = null;

      // 3.2) Fetch recommendations
      let recs = [];
      const params = new URLSearchParams();
      params.set('type', 'product-page');
      params.set('session_id', getRecSessionId());
      params.set('shopify_product_ids', seedId);
      
      if (customerProfile) {
        params.set('customer_profile', typeof customerProfile === 'string' ? customerProfile : JSON.stringify(customerProfile));
      }
      params.set('metafields', 'yes');
      params.set('variant_metafields', 'true');
      params.set('format', 'pretty');
      params.set('limit', '10');
      params.set('time', new Date().toISOString());
      const requestUuid = crypto.randomUUID ? crypto.randomUUID() : `uuid-${Date.now()}`;
      params.set('uuid', requestUuid);
      params.set('url', window.location.pathname);
      const localeCountry = ((navigator.language || '').split('-').pop() || '').toUpperCase();
      const cc = /^[A-Z]{2}$/.test(localeCountry) ? localeCountry : null;
      if (cc) params.set('country_code', cc);
      try {
        console.log('[Product]', `https://api.sowandarrow.com/recommendations?${params}`);
        const res  = await fetch(`https://api.sowandarrow.com/recommendations?${params}`, {
          method:      'GET',
          mode:        'cors',
          credentials: 'include',
        });
        const json = await res.json();

        const responseRequestUuid = json.request_uuid || requestUuid;
        const source = Array.isArray(json.products) ? json.products : [];
        recs = source
          .map(toCardRecommendation)
          .filter((rec) => rec.url && rec.variantId)
          .map((rec) => ({ ...rec, __request_uuid: responseRequestUuid }))
          .slice(0, 10);
      } catch (e) { /* silently ignore */ }

      recs = recs.filter((rec) => !inCart.has(String(rec.variantId)));
      if (!recs.length) { wrapper.style.display = 'none'; return; }

      // 3.3) Auto-open after a brief delay
      setTimeout(() => {
        readyToOpen = true;
        summary.style.pointerEvents = '';
        details.open = true;
        summary.click();
      }, 500);

      // 3.4) Render each card
      carousel.innerHTML = '';
      for (const rec of recs) {
        const frag = document.createRange().createContextualFragment(tpl.innerHTML);
        const card = frag.firstElementChild;
        card.classList.add('active');
        // link, image, title
        const linkEl = card.querySelector('a[data-instant]');
        const imgEl  = card.querySelector('img');
        const title  = card.querySelector('a.subheading');
         linkEl.href = rec.url;
         imgEl.src   = rec.image.src;
         imgEl.alt   = rec.image.alt;
         title.href  = rec.url;
         title.textContent = rec.title;

        const trackClick = () => {
          sendRecEvent({
            event_type: 'recommendation_click',
            recommendation_type: rec.reason || 'product-page',
            placement: 'product-cross-sell-legacy',
            request_uuid: rec.__request_uuid || requestUuid,
            source_product_id: seedId,
            product_id: rec.id,
            variant_id: rec.variantId,
            url: rec.url,
            customer_id: null
          });
          if (window.__storeRecContext) {
            window.__storeRecContext({
              product_id: rec.id,
              variant_id: rec.variantId,
              recommendation_type: rec.reason || 'product-page',
              placement: 'product-cross-sell-legacy',
              request_uuid: rec.__request_uuid || requestUuid,
              source_product_id: seedId,
              customer_id: null
            });
          }
        };
        linkEl.addEventListener('click', trackClick);
        title.addEventListener('click', trackClick);

        // price & stars
        const priceEl  = card.querySelector('.product-cross-sell__price');
        const ratingEl = card.querySelector('[data-loox-rating]');
        if (rec.priceCents != null) {
          priceEl.textContent = Shopify.formatMoney(rec.priceCents);
        }
        const rawRating = rec.rating;
        const rating    = rawRating != null ? parseFloat(rawRating) : NaN;
        if (!isNaN(rating) && rating > 0) renderStars(ratingEl, rating);
        else ratingEl.remove();

        // stock/options/add-to-cart form
        const variantId = rec.variantId;
        let inStock     = rec.available;
        let needsOptions = rec.variantCount > 1;
        if (!needsOptions) {
          try {
            const pd = await fetch(`${rec.url.replace(/\/$/,'')}.js`).then(r => r.json());
            const matchingVariant = pd.variants?.find((variant) => String(variant.id) === String(variantId));
            inStock = matchingVariant?.available ?? inStock;
            needsOptions = Array.isArray(pd.selling_plan_groups) && pd.selling_plan_groups.length;
          } catch {}
        }
        const placeholder = card.querySelector('button');
        const modal      = card.querySelector('quick-buy-modal');
        const qbId       = `${carouselId}-qb-${rec.id}`;

        if (!inStock) {
          // sold out button
          const f = document.createElement('form');
          f.className = 'product-cross-sell__form';
          const b = document.createElement('button');
          b.type = 'submit'; b.disabled = true;
          b.className = 'link subheading subheading-xs';
          b.textContent = "Sold out";
          f.append(b); placeholder.replaceWith(f);
          modal && modal.remove();

        } else if (needsOptions) {
          // choose options
          const f = document.createElement('form');
          f.className = 'product-cross-sell__form';
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'link subheading subheading-xs';
          b.textContent = "Choose options";
          b.setAttribute('aria-controls', qbId);
          f.append(b); placeholder.replaceWith(f);
          if (modal) { modal.id = qbId; modal.setAttribute('product-url', rec.url); }

        } else {
          // add to cart
          const f = document.createElement('form');
          f.className = 'product-cross-sell__form';
          f.method    = 'post';
          f.action    = '/cart/add.js';
          f.addEventListener('submit', async e => {
            e.preventDefault();
            try {
              const cart = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({ id: variantId, quantity: 1 })
              }).then(r => r.json());
              sendRecEvent({
                event_type: 'recommendation_add_to_cart',
                recommendation_type: rec.reason || 'product-page',
                placement: 'product-cross-sell-legacy',
                request_uuid: rec.__request_uuid || requestUuid,
                source_product_id: seedId,
                product_id: rec.id,
                variant_id: variantId,
                customer_id: null
              });
              document.dispatchEvent(new CustomEvent('variant:add',   { bubbles: true, detail: { items: [{ id: variantId, quantity: 1 }], cart } }));
              document.dispatchEvent(new CustomEvent('cart:change',  { bubbles: true, detail: { baseEvent: 'variant:add', cart } }));
              document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
              document.querySelector('a[href="/cart"],[data-drawer-toggle="cart"],.js-drawer-open-cart')?.click();
            } catch (err) { console.error('[Product] add-to-cart failed', err); }
          });
          const inp = document.createElement('input');
          inp.type = 'hidden'; inp.name = 'id'; inp.value = variantId;
          f.append(inp);
          const sb = document.createElement('button');
          sb.type = 'submit';
          sb.className = 'link subheading subheading-xs';
          sb.textContent = "Add to cart";
          f.append(sb);
          placeholder.replaceWith(f);
          modal && modal.remove();
        }

        carousel.appendChild(card);
        observeRecImpression(card, {
          recommendation_type: rec.reason || 'product-page',
          placement: 'product-cross-sell-legacy',
          request_uuid: rec.__request_uuid || requestUuid,
          source_product_id: seedId,
          product_id: rec.id,
          variant_id: rec.variantId,
          customer_id: null
        });
      }

      // 3.5) Prev/Next arrow logic
      function updateArrows() {
        const max = carousel.scrollWidth - carousel.clientWidth;
        prevBtn.classList.toggle('at-start', 0 >= carousel.scrollLeft);
        nextBtn.classList.toggle('at-end',   carousel.scrollLeft >= max);
      }
      updateArrows();
      prevBtn.addEventListener('click', e => {
        e.stopPropagation();
        if (!prevBtn.classList.contains('at-start')) {
          carousel.scrollBy({ left: -carousel.clientWidth, behavior: 'smooth' });
        }
      });
      nextBtn.addEventListener('click', e => {
        e.stopPropagation();
        if (!nextBtn.classList.contains('at-end')) {
          carousel.scrollBy({ left: carousel.clientWidth, behavior: 'smooth' });
        }
      });
      carousel.addEventListener('scroll', updateArrows);
    });
  });
})();
